import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_m1k27vexwy: FaireBrandEntity = {
  token: "b_m1k27vexwy",
  type: "brand",
  name: "Naked Zebra",
  avatarUrl:
    "https://cdn.faire.com/fastly/5dc5a2b308be55692354bf6136c304c56f7ed90715ddb44f07ade36a0d552929.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b348903c2ad15aa9ef77cfa097f4a641eb08ca3c1609168a7afe2aad5c3eb0ee.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5dc5a2b308be55692354bf6136c304c56f7ed90715ddb44f07ade36a0d552929.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b348903c2ad15aa9ef77cfa097f4a641eb08ca3c1609168a7afe2aad5c3eb0ee.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 116,
  isTopShop: true,
  isInsider: true,
  description:
    "Draped for Movement, Meant for Moments.\n\nEstablished in 2009 at the heart of Los Angeles' Fashion District, Naked Zebra embodies the spirit of embracing individuality and authenticity. We passionately celebrate women's confidence and uniqueness through our stylish and playful designs and colors. Our meticulously crafted garments effortlessly blend sophistication with ease, youthful daring with self-assured allure, resulting in a harmonious expression of modern femininity. At Naked Zebra, we adhere to a commitment to quality that sets us apart from the fast fashion industry.\n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:43.711Z",
    importedBy: "entity-db-cli",
  },
};
